
import gql from 'graphql-tag';
import QuickGuideWrapper from '../../../components/quick-guide/QuickGuideWrapper.vue';
import termCIPlanScenariosQuery from '~/apollo/queries/product/termCIPlanScenarios';
import insuranceCompaniesQuery from '~/apollo/queries/product/insuranceCompanies';
import productPromotionFragment from '~/apollo/fragments/productPromotionFragment';
import termCITooltips from '~/apollo/queries/product/tooltips/termCITooltips';
import commonProductMixins from '~/mixins/commonProductMixins.js';
import productPromotionMixins from '~/mixins/productPromotionMixins.js';
import insuranceGuideQuery from '@/apollo/queries/home/insuranceguide'
import productShortcutMixins from "~/mixins/productShortcutMixins.js";
import apolloQuickGuideMixins from '~/mixins/apolloQuickGuideMixins';
import productInsuranceNameMixins from '~/mixins/productInsuranceNameMixins';

export default {
  name: 'ProductsTermCriticalIllnessListingPage',
  mixins: [commonProductMixins, productPromotionMixins, productShortcutMixins, apolloQuickGuideMixins, productInsuranceNameMixins],

  apollo: {
    $loadingKey: 'loading',
    termCiPlanScenarios: {
      query: gql`
        ${termCIPlanScenariosQuery}
        ${productPromotionFragment}
      `,
      prefetch: true,
      variables() {
        let tmpComp;
        tmpComp = undefined;
        let tmpRenewalTerm;
        tmpRenewalTerm = undefined;

        let tmpCancerScore;
        tmpCancerScore = undefined;

        let tmpHeartScore;
        tmpHeartScore = undefined;

        let tmpStrokeScore;
        tmpStrokeScore = undefined;

        let tmpOtherCIScore;
        tmpOtherCIScore = undefined;

        let tmpBrokerInd;
        tmpBrokerInd = undefined;

        if (this.filter.insCompValue?.length) {
          tmpComp = this.filter.insCompValue.map((x) => x.value);
        }

        if (this.filter.renewalTermValue?.value !== '-1') {
          tmpRenewalTerm = parseInt(this.filter.renewalTermValue?.value);
        }

        if (this.filter.ciCoverageValue?.value !== '-1') {
          // check score for filter type
          if (this.filter.ciCoverageValue?.value === 'C') {
            tmpCancerScore = 0;
          } else if (this.filter.ciCoverageValue?.value === 'H') {
            tmpHeartScore = 0;
          } else if (this.filter.ciCoverageValue?.value === 'S') {
            tmpStrokeScore = 0;
          } else if (this.filter.ciCoverageValue?.value === 'O') {
            tmpOtherCIScore = 0;
          }
        }

        if (this.filter.advisorAssistanceValue) {
          tmpBrokerInd = this.filter.advisorAssistanceValue;
        }

        return {
          insCompCode: tmpComp,
          gender: parseInt(this.filter.genderValue?.value),
          age: parseInt(this.filter.ageValue?.value),
          renewal_term: tmpRenewalTerm,
          sum_assured: parseInt(this.filter.sumAssuredValue?.value),
          cancer_score: tmpCancerScore,
          heart_score: tmpHeartScore,
          stroke_score: tmpStrokeScore,
          other_ci_score: tmpOtherCIScore,
          ten_year_average_premium_from: parseFloat(this.filter.annualPremiumValue?.value[0]),
          ten_year_average_premium_to: parseFloat(this.filter.annualPremiumValue?.value[1]),
          broker_ind: tmpBrokerInd,
          locale: this.currentLocale,
        };
      },
    },
    insuranceCompanies: {
      query: insuranceCompaniesQuery,
      prefetch: true,
      variables() {
        return {
          show_termci: true,
        };
      },
      update(data) {
        return data.insuranceCompanies.data.map((item) => {
          const translations = item.attributes.insurance_company_translations.data;
          // console.debug(translations);
          const filteredTranslations = this.getFilteredTranslations(translations);
          return {
            value: item.attributes.code,
            text:
              filteredTranslations[0].attributes.name +
              ' | ' +
              filteredTranslations[1].attributes.name,
          };
        });
      },
    },
    termCITooltips: {
      query: termCITooltips,
      prefetch: true,
      variables() {
        return { currentlocale: this.$normalizeLocale(this.$i18n.locale) };
      },
      update(data) {
        return this.$normalizeStrapi(data.infoTooltip.data);
      },
    },
  },
  data() {
    return {
      loading: 0,
      currentLocale: this.$normalizeLocale(this.$i18n.locale),

      filter: {
        insCompValue: [],

        genderValue: {
          value: this.$route.query.gender ? this.$route.query.gender : '1',
          text: this.$t('products.male'),
        },
        genderOptions: [
          { value: '1', text: this.$t('products.male') },
          { value: '2', text: this.$t('products.female') },
        ],

        ageValue: { value: this.$route.query.age ? this.$route.query.age : '35', text: '35' },
        ageOptions: [
          { value: '25', text: '25' },
          { value: '30', text: '30' },
          { value: '35', text: '35' },
          { value: '40', text: '40' },
          { value: '45', text: '45' },
        ],

        renewalTermValue: {
          value: this.$route.query.renewal_term ? this.$route.query.renewal_term : '-1',
          text: this.$t('products.any'),
        },
        renewalTermOptions: [
          { value: '-1', text: this.$t('products.any') },
          { value: '1', text: this.getRenewal(this.$t('products.renewalUnit'), 1) },
          { value: '5', text: this.getRenewal(this.$t('products.renewalUnit'), 5) },
          { value: '10', text: this.getRenewal(this.$t('products.renewalUnit'), 10) },
        ],

        sumAssuredValue: {
          value: this.$route.query.sum_assured ? this.$route.query.sum_assured : '1000000',
          text: '500,000',
        },
        sumAssuredOptions: [
          { value: '500000', text: '500,000' },
          { value: '1000000', text: '1,000,000' },
        ],

        annualPremiumValue: {
          value: [
            this.$route.query.annual_premium_from ? parseInt(this.$route.query.annual_premium_from) : 0,
            this.$route.query.annual_premium_to ? parseInt(this.$route.query.annual_premium_to) : 30000,
          ],
          text: this.$t('products.termci.tci_10YearAverageAnnualPremium'),
        },
        annualPremiumOptions: [
          {
            value: [
              this.$route.query.annual_premium_from ? parseInt(this.$route.query.annual_premium_from) : 0,
              this.$route.query.annual_premium_to ? parseInt(this.$route.query.annual_premium_to) : 30000,
            ],
            text: this.$t('products.termci.tci_10YearAverageAnnualPremium'),
          },
        ],
        annualPremiumSliderRange: [0, 30000],

        ciCoverageValue: {
          value: this.$route.query.ci_coverage ? this.$route.query.ci_coverage : '-1',
          text: this.$t('products.any'),
        },
        ciCoverageOptions: [
          { value: '-1', text: this.$t('products.any') },
          { value: 'C', text: this.$t('products.termci.tci_cancerCoverage') },
          { value: 'H', text: this.$t('products.termci.tci_heartCoverage') },
          { value: 'S', text: this.$t('products.termci.tci_strokeCoverage') },
          { value: 'O', text: this.$t('products.termci.tci_otherCriticalIllnessCoverage') },
        ],

        advisorAssistanceValue: this.$route.query.advisorAssistance === 'true',
      },
      perPage: 15,
      currentPage: 1,
      termCiPlanScenarios: null,
      insuranceCompanies: [],

      sortingData: {
        title: this.$t('products.sort'),
        sortValue: { value: this.$route.query.sort ? this.$route.query.sort : 'five_star', text: '' },
        sortingOptions: [
          { value: 'five_star', text: this.$t('products.termci.tci_5StarRatings') },
          { value: 'score', text: this.$t('products.termci.tci_termCIScore') },
          { value: 'ten_year_average_premium', text: this.$t('products.termci.tci_10yearAvgPremiumLowtoHigh') },
          { value: 'first_year_premium', text: this.$t('products.termci.tci_firstYearPremiumLowtoHigh') },
        ],
      },
    };
  },

  computed: {
    modalOpen() {
        return this.$store.getters['modal/showDisplayMobileFilter'].isOpen
    },
    mainQueryLoading() {
      return this.$apollo.queries.termCiPlanScenarios.loading;
    },

    resultMessage() {
      if (this.mainQueryLoading) {
        return this.$t('products.termci.tci_result').replace('$num', '{ }');
      } else {
        return this.$t('products.termci.tci_result').replace('$num', this.rows);
      }
    },

    displayProducts() {
      return this.sortedItem?.map((item) => ({
        id: item.scenario_code,
        category: this.category,
        scenarioId: item.scenarioID,
        showFiveStarBadge: this.$formatShowFiveStarBadge(item.overall_star),
        showTrending: false,

        productLink: this.$extendPath(this.$route.path, '/' + item.scenario_code),
        productName: item.plan_name,
        insuranceCompany: {
          name: item.insurer_name_first + ' | ' + item.insurer_name_second,
          code: item.insurer_code,
          logoSrc: item.insurer_logo?.data?.attributes.url,
          logoAlt: item.insurer_name_first,
        },
        userRating: {
          score: item.overall_star,
          numberOfRatedUser: '0',
        },
        tenlifeScore: {
          score: parseFloat(this.getScore(item)),
          description: this.$t('products.termci.tci_termCIScore'),
          toolTipHtml: this.getTooltipContentByKey('tci_termCIScore'),
        },
        features: [
          {
            text: this.getRenewal(this.$t('products.renewalUnit'), item.renewal_term),
            type: 'renewal_term',
          },
          {
            text: item.ci_type,
            type: 'multiple_claims',
          },
          {
            text: item.underwriting_text,
            type: 'underwriting',
          },
        ],
        keyItems: [
          {
            value: this.getCoverageText(item.cancer_score, item.heart_score, item.stroke_score, item.other_ci_score),
            key: this.$t('products.termci.tci_cICoverage'),
            topSubText: '',
            toolTipHtml: '',
            symbolValue: '',
            originalValue: '',
            mode: 'long-text',
          },
          {
            value: item.discounted_ten_year_avg_premium
              ? this.$formatPrice(item.discounted_ten_year_avg_premium)
              : this.$formatPrice(item.ten_year_average_premium),
            key: this.$t('products.termci.tci_10yearAvgPremium'),
            topSubText: item.currency,
            toolTipHtml: '',
            symbolValue: '',
            originalValue: item.discounted_ten_year_avg_premium ? this.$formatPrice(item.ten_year_average_premium) : '',
          },
        ],
        compactKeyItems: [
          // {
          //   value: item.promotion_prices[0]
          //     ? this.$formatPrice(item.promotion_prices[0])
          //     : this.$formatPrice(item.first_year_premium),
          //   key: this.$t('products.termci.tci_firstYearPremium'),
          //   topSubText: item.currency,
          //   toolTipHtml: '',
          //   symbolValue: '',
          //   originalValue: item.promotion_prices[0] ? this.$formatPrice(item.first_year_premium) : '',
          // },
          {
            value: this.getCoverageText(
              item.cancer_score,
              item.heart_score,
              item.stroke_score,
              item.other_ci_score,
              'compact'
            ),
            key: this.$t('products.termci.tci_cICoverage'),
            topSubText: '',
            toolTipHtml: '',
            symbolValue: '',
            originalValue: '',
            mode: 'long-text',
          },
        ],
        mobileKeyItems: [
          {
            value: this.getCoverageText(
              item.cancer_score,
              item.heart_score,
              item.stroke_score,
              item.other_ci_score,
              'mobile'
            ),
            key: this.$t('products.termci.tci_cICoverage'),
            topSubText: '',
            toolTipHtml: '',
            symbolValue: '',
            originalValue: '',
            mode: 'long-text',
          },
          {
            value: item.discounted_ten_year_avg_premium
              ? this.$formatPrice(item.discounted_ten_year_avg_premium)
              : this.$formatPrice(item.ten_year_average_premium),
            key: this.$t('products.termci.tci_10yearAvgPremium'),
            topSubText: item.currency,
            toolTipHtml: '',
            symbolValue: '',
            originalValue: item.discounted_ten_year_avg_premium ? this.$formatPrice(item.ten_year_average_premium) : '',
            isTextBold: true
          },
        ],
        promotion: {
          category:
            item.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.PromotionCategory,
          title:
            item.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.PromotionTitle,
          ctaButtonLink:
            item.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.CTAButtonLink,
          ctaButtonText:
            item.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.CTAButtonText,
          promotionId: item.product_promotion?.id,
          scenarioId: item.scenarioID,
          lastCall: item.promotion_last_call

        },
        mainButtonCTA: {
          text: item.decoder_cta_text,
          link: item.decoder_cta_link,
        },
        showShortcut: item.shortcut,
        price: {
          originalPrice: item.promotion_prices[0] ? this.$formatPrice(item.first_year_premium) : '',
          discountPrice: item.promotion_prices[0]
            ? this.$formatPrice(item.promotion_prices[0])
            : this.$formatPrice(item.first_year_premium),
          prefix: item.currency,
          postfix: '',
          subText: this.$t('products.termci.tci_firstYearPremium'),
          toolTipHtml: '',
        },
      }));
    },

    rows() {
      if (this.simpleItems) {
        return this.simpleItems.length;
      }
      return null;
    },

    sortedItem() {
      if (this.sortingData.sortValue.value === 'five_star') {
        if (this.simpleItems) {
          return this.simpleItems
            .map((item) => item)
            .sort((a, b) => {
              // for 2nd and 3rd ranking
              let aPrem = a.first_year_premium;
              let bPrem = b.first_year_premium;
              if (a.promotion_prices[0]) {
                aPrem = a.promotion_prices[0];
              }
              if (b.promotion_prices[0]) {
                bPrem = b.promotion_prices[0];
              }

              let aAvgPrem = a.ten_year_average_premium;
              let bAvgPrem = b.ten_year_average_premium;
              if (a.discounted_ten_year_avg_premium) aAvgPrem = a.discounted_ten_year_avg_premium;
              if (b.discounted_ten_year_avg_premium) bAvgPrem = b.discounted_ten_year_avg_premium;

              return  Number(this.$formatShowFiveStarBadge(b.overall_star)) - Number(this.$formatShowFiveStarBadge(a.overall_star)) || b.rating - a.rating || aAvgPrem - bAvgPrem || aPrem - bPrem;
            });
        }
      }
      else if (this.sortingData.sortValue.value === 'score') {
        if (this.simpleItems) {
          return this.simpleItems
            .map((item) => item)
            .sort((a, b) => {
              // for 2nd and 3rd ranking
              let aPrem = a.first_year_premium;
              let bPrem = b.first_year_premium;
              if (a.promotion_prices[0]) {
                aPrem = a.promotion_prices[0];
              }
              if (b.promotion_prices[0]) {
                bPrem = b.promotion_prices[0];
              }

              let aAvgPrem = a.ten_year_average_premium;
              let bAvgPrem = b.ten_year_average_premium;
              if (a.discounted_ten_year_avg_premium) aAvgPrem = a.discounted_ten_year_avg_premium;
              if (b.discounted_ten_year_avg_premium) bAvgPrem = b.discounted_ten_year_avg_premium;

              return b.rating - a.rating || Number(this.$formatShowFiveStarBadge(b.overall_star)) - Number(this.$formatShowFiveStarBadge(a.overall_star)) || aAvgPrem - bAvgPrem || aPrem - bPrem;
            });
        }
      } else if (this.sortingData.sortValue.value === 'first_year_premium') {
        if (this.simpleItems) {
          return this.simpleItems
            .map((item) => item)
            .sort((a, b) => {
              let aPrem = a.first_year_premium;
              let bPrem = b.first_year_premium;
              if (a.promotion_prices[0]) {
                aPrem = a.promotion_prices[0];
              }
              if (b.promotion_prices[0]) {
                bPrem = b.promotion_prices[0];
              }

              let aAvgPrem = a.ten_year_average_premium;
              let bAvgPrem = b.ten_year_average_premium;
              if (a.discounted_ten_year_avg_premium) aAvgPrem = a.discounted_ten_year_avg_premium;
              if (b.discounted_ten_year_avg_premium) bAvgPrem = b.discounted_ten_year_avg_premium;

              return aPrem - bPrem ||Number(this.$formatShowFiveStarBadge(b.overall_star)) - Number(this.$formatShowFiveStarBadge(a.overall_star)) || b.rating - a.rating || aAvgPrem - bAvgPrem;
            });
        }
      } else if (this.sortingData.sortValue.value === 'ten_year_average_premium') {
        if (this.simpleItems) {
          return this.simpleItems
            .map((item) => item)
            .sort((a, b) => {
              let aPrem = a.first_year_premium;
              let bPrem = b.first_year_premium;
              if (a.promotion_prices[0]) {
                aPrem = a.promotion_prices[0];
              }
              if (b.promotion_prices[0]) {
                bPrem = b.promotion_prices[0];
              }

              let aAvgPrem = a.ten_year_average_premium;
              let bAvgPrem = b.ten_year_average_premium;
              if (a.discounted_ten_year_avg_premium) aAvgPrem = a.discounted_ten_year_avg_premium;
              if (b.discounted_ten_year_avg_premium) bAvgPrem = b.discounted_ten_year_avg_premium;

              return aAvgPrem - bAvgPrem || Number(this.$formatShowFiveStarBadge(b.overall_star)) - Number(this.$formatShowFiveStarBadge(a.overall_star)) || b.rating - a.rating || aPrem - bPrem;
            });
        }
      }
      return null;
    },

    simpleItems() {
      if (this.termCiPlanScenarios) {
        return this.termCiPlanScenarios.data.map((item) => {
          let promotionPrices = Object;
          promotionPrices = {};
          let discountedTenYearAvgPremium = null;
          let promotions = null;
          let promotion = null;
          let promotion_last_call = null;

          const planName =
            item.attributes.term_ci_plan.data.attributes.term_ci_plan_translations.data[0].attributes.name;
          const insurer = item.attributes.term_ci_plan.data.attributes.product.data.attributes.insurance_company.data.attributes.insurance_company_translations.data[0].attributes.name;
          let decoderCTALink = this.$generateWhatsappCTALink(this.$t('products.termci.tci_categoryName'), insurer, planName);
          let decoderCTAText = '';

          // check scenario level promo first , then plan level promotion
          if (item.attributes.product_promotions.data?.length > 0) {
            promotions = item.attributes.product_promotions.data;
          }
          if (item.attributes.term_ci_plan.data.attributes.product_promotions.data?.length > 0) {
            promotions = item.attributes.term_ci_plan.data.attributes.product_promotions.data;
          }

          if(promotions != null) {
            promotion = this.checkPromotionValid(promotions);
            promotion_last_call = this.checkPromotionLastCall(promotion);

            if (!promotion) {
              promotion = null;
            } else {
              if (promotion.attributes?.product_promotion_translations?.data[0]?.attributes?.DecoderCTALink) {
                decoderCTALink =
                  promotion.attributes?.product_promotion_translations?.data[0]?.attributes?.DecoderCTALink;
                decoderCTAText = this.$t('products.product_website');
              }
              const discounts = promotion.attributes.DiscountPercentage;
              if (discounts) {
                // calculate promotion price and avg premium
                let originalPrices = Array;
                originalPrices = [];
                for (let i = 0; i < 10; i++) {
                  originalPrices[i] = item.attributes['premium_display_' + parseInt(i + 1)];
                }
                const calulatedValue = this.calculateDiscountedPremium(originalPrices, discounts);

                promotionPrices = calulatedValue.promotionPrices;
                discountedTenYearAvgPremium = calulatedValue.discountedTenYearAvgPremium;

                if (discountedTenYearAvgPremium === parseInt(item.attributes.ten_year_average_premium.toFixed(0))) {
                  discountedTenYearAvgPremium = null;
                }
              }
            }
          }

          const shortcut = this.getProductShortcut(item.attributes);

          const filteredTranslations = this.getFilteredTranslations(item.attributes.term_ci_plan.data.attributes.product.data.attributes.insurance_company.data.attributes
          .insurance_company_translations.data[0].attributes.localizations.data);

          return {
            currency: item.attributes.currency.data.attributes.code,
            scenario_code: item.attributes.scenario_code,
            sum_assured: item.attributes.sum_assured,
            age: item.attributes.age,
            cancer_score: item.attributes.cancer_score,
            heart_score: item.attributes.heart_score,
            stroke_score: item.attributes.stroke_score,
            other_ci_score: item.attributes.other_ci_score,
            general_term_score: item.attributes.general_term_score,
            rating: item.attributes.rating.toFixed(1),
            renewal_term: item.attributes.renewal_term,
            first_year_premium: item.attributes.first_year_premium,
            ten_year_average_premium: item.attributes.ten_year_average_premium,

            overall_star: item.attributes.term_ci_plan.data.attributes.overall_star,

            // plan
            plan_name: planName,
            underwriting_text:
              item.attributes.term_ci_plan.data.attributes.term_ci_plan_translations.data[0].attributes
                .underwriting_text,
            ci_type: item.attributes.term_ci_plan.data.attributes.term_ci_plan_translations.data[0].attributes.ci_type,

            // insurer
            insurer_name_first:
              item.attributes.term_ci_plan.data.attributes.product.data.attributes.insurance_company.data.attributes
                .insurance_company_translations.data[0].attributes.name,
            insurer_name_second:
              filteredTranslations[0].attributes.name,
            insurer_logo:
              item.attributes.term_ci_plan.data.attributes.product.data.attributes.insurance_company.data.attributes
                .logo,
            insurer_code:
              item.attributes.term_ci_plan.data.attributes.product.data.attributes.insurance_company.data.attributes
                .code,

            product_promotion: promotion,
            promotion_prices: promotionPrices,
            promotion_last_call: promotion_last_call,

            discounted_ten_year_avg_premium: discountedTenYearAvgPremium,
            decoder_cta_link: decoderCTALink,
            decoder_cta_text: decoderCTAText,

            scenarioID: item.id,
            shortcut: shortcut
          };
        });
      }
      return null;
    },
    slug() {
      return 'term-ci'
    },
    selectedSortingLogic() {
      return this.sortingData.sortValue.value
    },
  },

  created() {
    const filterValuesToWatch = [
      {
        filterValuePath: 'filter.genderValue',
        filterOptionsPath: 'filter.genderOptions',
        queryKey: 'gender',
        defaultValue: '1',
      },
      {
        filterValuePath: 'filter.ageValue',
        filterOptionsPath: 'filter.ageOptions',
        queryKey: 'age',
        defaultValue: '35',
      },
      {
        filterValuePath: 'filter.sumAssuredValue',
        filterOptionsPath: 'filter.sumAssuredOptions',
        queryKey: 'sum_assured',
        defaultValue: '1000000',
      },
      {
        filterValuePath: 'filter.renewalTermValue',
        filterOptionsPath: 'filter.renewalTermOptions',
        queryKey: 'renewal_term',
        defaultValue: '-1',
      },
      {
        filterValuePath: 'filter.ciCoverageValue',
        filterOptionsPath: 'filter.ciCoverageOptions',
        queryKey: 'ci_coverage',
        defaultValue: '-1',
      },
      {
        filterValuePath: 'sortingData.sortValue',
        filterOptionsPath: 'sortingData.sortingOptions',
        queryKey: 'sort',
        defaultValue: 'five_star',
      },
      {
        filterValuePath: 'filter.insCompValue',
        filterOptionsPath: 'insuranceCompanies',
        queryKey: 'ins_comp[]',
        defaultValue: [],
        ignoreFix: true,
        type: 'array',
      },
      {
        filterValuePath: 'filter.annualPremiumValue.value[0]',
        queryKey: 'annual_premium_from',
        defaultValue: 0,
        ignoreFix: true,
        type: 'slider',
      },
      {
        filterValuePath: 'filter.annualPremiumValue.value[1]',
        queryKey: 'annual_premium_to',
        defaultValue: 30000,
        ignoreFix: true,
        type: 'slider',
      },
      {
        filterValuePath: 'filter.advisorAssistanceValue',
        queryKey: 'advisorAssistance',
        defaultValue: false,
        ignoreFix: true,
        type: 'checkbox',
      },
    ];

    this.createFilterWatchers(filterValuesToWatch);
    this.fixFilterValues(filterValuesToWatch);
  },

  mounted() {
    const filterArrayValueToFix = {
      filterValuePath: 'filter.insCompValue',
      filterOptionsPath: 'insuranceCompanies',
      queryKey: 'ins_comp[]',
    };

    this.fixFilterArrayValueDueToQueryString(filterArrayValueToFix);
  },

  methods: {
    getScore(product) {
      return product.rating;
    },
    getAvgPremium(filter, product) {
      if (filter.targetPeriodValue?.value === '10') {
        return product.ten_year_avg_premium.toLocaleString('en-US');
      } else if (filter.targetPeriodValue?.value === '20') {
        return product.twenty_year_avg_premium.toLocaleString('en-US');
      }
      return 0;
    },

    getRenewal(label, renewalTerm) {
      if (renewalTerm === 1) {
        return this.$t('products.annualRenewal');
      }
      return label.replace('$num', renewalTerm);
    },

    getCoverageText(cancerScore, heartScore, strokeScore, otherCIScore, mode = 'list') {
      const renderText = (score, text) => {
        const resultText = score <= 0 ? '<span style="color:#C9C1C1;">' + text + '</span>' : text;
        let spanStyle = '';

        switch (mode) {
          case 'compact':
            spanStyle = '<span style="display: inline-block; margin-left: 10px; font-weight: bold;">';
            break;

          case 'mobile':
            spanStyle = '<span style="display: inline-block; margin-left: 10px; font-weight: bold;">';
            break;

          default:
            spanStyle = '<span style="display: inline-block; margin-right: 18px;">';
            break;
        }
        return spanStyle + resultText + '</span>';
      };
      const resultCancer = renderText(cancerScore, this.$t('products.termci.tci_cancer'));
      const resultHeart = renderText(heartScore, this.$t('products.termci.tci_heart'));
      const resultStroke = renderText(strokeScore, this.$t('products.termci.tci_stroke'));
      const resultOthers = renderText(otherCIScore, this.$t('products.termci.tci_otherCriticalIllness'));
      return resultCancer + resultHeart + resultStroke + resultOthers;
    },

    getTooltipContentByKey(mKey) {
      return this.termCITooltips?.TermCI?.ToolTips?.find(({ Key }) => Key === mKey)?.ToolTipContent ?? '';
    },
  },
  components: {
    QuickGuideWrapper
  }
};
